import { Component, OnInit, NgZone, AfterViewInit, ViewChild } from '@angular/core';
import { BrandingService } from '../Services/BrandingService';
import { Router, ActivatedRoute } from '@angular/router';
import { DxFormComponent } from 'devextreme-angular';

//services
import { Registration } from '../Services/Registration';
import { SettingService } from '../Services/SettingService';
import { TranslateService } from '@ngx-translate/core';

@Component({
    styles: [`
.logo {
    margin-left: auto;
    margin-right: auto;
    display: block;
    height: 45px;
}

.confirmation-text {
    color: #333333;
    font-family: Arial;
    font-size: 18px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 24px;
    text-align: center;
    padding-bottom: 16px;
}

.confirmation-description {
    color: #333333;
    font-family: Arial;
    font-size: 16px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 24px;
    text-align: center;
}

.right-link {
    margin-left: auto;
}

.links {
    display: flex;
    flex-direction: row;
    color: #009FDE;
    font-family: Arial;
    font-size: 14px;
    letter-spacing: 0;
    line-height: 24px;
    margin-top: 24px;
}

.link {
    text-decoration: none;
    color: #009FDE;
}

.box {
    margin-top: 48px;
    background-color: #FFFFFF;
    width: 500px;
    height: auto;
    margin: 0 auto;
    padding: 24px;
    margin-top: 48px;
}

.policy {
    text-align: center;
    padding-top: 16px;
}

.container{
    height: 100%;
    width: 100%;
    background-color: #F4FAFC;
    display: flex;
}

.reset-panel{
    padding-top: 60px;
    margin: 0 auto;
    width: 100%;
}

.policy-link {
    color: #003952;
    font-family: Arial;
    font-size: 14px;
    letter-spacing: 0;
    line-height: 24px;
    text-align: center;
    text-decoration: none;
}

.reset-btn{
    color: #FFFFFF;
    font-family: Arial;
    font-size: 16px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 18px;
    text-align: center;
    background-color: #00A698;
}

.reset-btn:hover {
    background-color: #079488 !important;
}

.errorMsg{
    color: #333333;
    font-family: Arial;
    font-size: 16px;
    letter-spacing: 0;
    line-height: 18px;
    margin: auto 0;
    overflow: initial;
    text-align: left;
    word-break: break-word;
}

.errorbox{
    width: 100%;
    background-color: #FFEEEE;
    flex-direction:row;
    display: inline-flex;
    margin-bottom: 16px;
}

.standard-text-color {
    color: #333333;
}

.link-text-color {
    color: #009fde;
}

.ToS-text-color {
    color: #003952;
}

.sign-in-button {
    background-color: #00A698;
    color: #fff;
}

#light-mode {
    display: block;
}

#dark-mode {
    display: none;
}

::ng-deep .en:before {
    background-image: url(/identity/content/icons/usa_flag.png) !important;
}

::ng-deep .br:before {
    background-image: url(/identity/content/icons/brazil_flag.png) !important;
}

::ng-deep .es:before {
    background-image: url(/identity/content/icons/spain_flag.png) !important;
}

::ng-deep .dropdown-icon {
    content: url("/identity/content/icons/dropdown-button.png")
}


.bullet-list {
    font-size: 12px;
    margin: 8px 24px;
}

@media (prefers-color-scheme: dark) {
    .standard-text-color {
        color: #E6E6E6;
    }

    .box{
        background-color: #333333;
    }

    .ToS-text-color {
        color: #1CA8DD;
    }

    .link-text-color {
        color: #1CA8DD;
    }

    .background {
        background-color: #2A2A2A;
    }

    .sign-in-button {
        background-color: #1CA8DD;
        border: 0 !important;
    }

    ::ng-deep.dx-texteditor {
        background-color: #2A2A2A !important;
        border: 1px solid #454545 !important;
    }

    ::ng-deep .dx-field-item-label-text {
        color: #E6E6E6 !important;
    }

    ::ng-deep .dx-texteditor-input{
        color: #E6E6E6;
    }

    #light-mode {
        display: none !important;
    }

    #dark-mode {
        display: block !important;
    }
}


/* for mobile*/
@media (max-width: 768px) {
    .box{
        width: calc( 100% - 48px);
    }

    .formcontainer{
        width: calc( 100% - 24px);
        padding-top: 16px;
    }

    .links, .confirmation-text{
        width: calc( 100% - 48px);
    }
}
    `],
    template: `
    <div class="container background">
        <div class="reset-panel">
            <ng-container *ngIf="!branding.hideLogo">
                <img id="light-mode" class="logo" [src]="branding.logoUrl" alt="" />
                <img id="dark-mode" class="logo" [src]="branding.logoUrlDark" alt="" />
            </ng-container>
            <div class="box">
                <p class="confirmation-text standard-text-color">{{'Reset your password' | translate}}</p>
                <div class="formcontainer">
                    <div class="errorbox" *ngIf="errorMessage">
                        <img style="height: 16px; width: 16px; padding: 18px 16px;" src="/identity/content/icons/high-priority.png" />
                        <div class="errorMsg">{{errorMessage}}</div>
                    </div>
                    <dx-form
                        [readOnly]="false"
                        [showRequiredMark]="false"
                        [showColonAfterLabel]="false"
                        labelLocation="top"
                        [minColWidth]="300"
                        [colCount]="1">
                        <dxi-item
                            [editorOptions]="{ mode: 'password' }"
                            dataField="Password">
                            <dxo-label [text]="'Password' | translate"></dxo-label>
                            <dxi-validation-rule type="required"></dxi-validation-rule>
                            <dxi-validation-rule type="pattern"
                                [pattern]="password_regex"
                                message="A password has to contain at least one numeric character, one lower case character, one upper case character, and one symbol; and must be a minimum length of 8 characters."
                                ></dxi-validation-rule>
                        </dxi-item>
                        <dxi-item
                            itemType="empty">
                        </dxi-item>
                        <dxi-item
                            [editorOptions]="{ mode: 'password' }"
                            dataField="Password2">
                            <dxo-label [text]="'Verify Password' | translate"></dxo-label>
                            <dxi-validation-rule type="required"></dxi-validation-rule>
                            <dxi-validation-rule type="custom" [reevaluate]="true" [validationCallback]="this.matchPassword" message="These passwords don't match."></dxi-validation-rule>
                        </dxi-item>
                    </dx-form>
                    <ul class="bullet-list standard-text-color">
                        <li>{{'One lowercase character' | translate }}</li>
                        <li>{{'One uppercase character' | translate }}</li>
                        <li>{{'One numeric character' | translate }}</li>
                        <li>{{'One special character' | translate }}</li>
                        <li>{{'8 characters minimum' | translate }}</li>
                    </ul>
                    <div style="height:19px;width:100%;"></div>
                    <dx-button class="reset-btn sign-in-button" [text]="'Update password' | translate" (onClick)="onSubmit()" width="100%" [height]="45" [disabled]="loadIndicatorVisible || disabledNotifications">
                        <div *dxTemplate="let data of 'content'">
                            <dx-load-indicator class='button-indicator' height="20" width="20" style='position:absolute; right: 955px; margin-top: 3px;'
                                [visible]="loadIndicatorVisible">
                            </dx-load-indicator>
                            <div class='dx-button-text' style='margin-left: auto;'>{{"Update password" | translate}}</div>
                        </div>
                    </dx-button>
                </div>
                <div class="links">
                    <div>
                        <a class="link" href="../../">{{'Sign in' | translate}}</a>
                    </div>
                    <div class="right-link">
                        <a class="link" href="../Register">{{'Sign up for an account' | translate}}</a>
                    </div>
                </div>
            </div>
            <p class="policy">
                <a class="policy-link ToS-text-color" [href]="branding.privacyPolicyUrl" target="_blank" rel="noopener noreferrer">{{'Privacy Policy' | translate}}</a>
                <span class="dot" style="margin: auto 0;"> • </span>
                <a class="policy-link ToS-text-color" [href]="branding.termsOfServiceUrl" target="_blank" rel="noopener noreferrer">{{'Terms of Service' | translate}}</a>
            </p>
        </div>
    </div>
    `,
    providers: [Registration, SettingService]
})

export class ResetPasswordVerified implements OnInit {
    @ViewChild(DxFormComponent) form: DxFormComponent;
    errorMessage: string = null;
    loadIndicatorVisible: boolean = false;
    disabledNotifications: boolean = false;
    formItems: any[];

    userName: string;
    token: string;

    password_regex: RegExp = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*\_\{\}\[\]\(\)'"`~,;:.<>\-+\|\?\/\\])(?=.{8,})/;

    constructor(public branding: BrandingService, private _router: Router, private _route: ActivatedRoute, private _registrationService: Registration, private zone: NgZone, private _settings: SettingService,
        private translate: TranslateService) {
        this.userName = this._route.snapshot.queryParams['username'];
        this.token = this._route.snapshot.queryParams['token'];
        this.matchPassword = this.matchPassword.bind(this);
        let cookie = document.cookie.match(new RegExp('(^| )Language=([^;]+)'))
        this.translate.use(cookie && cookie[2] ? cookie[2] : "en");
    }

    ngOnInit() {
        this.errorMessage = null;
        this._registrationService.verifyResetPasswordRequest({ UserName: this.userName, Token: this.token, Password:'' })
            .then(res => {
                if (res.Status !== true) {
                    this.errorMessage = res.Message;
                }
            },
                er => {
                    this.errorMessage = er.Message;
                })
    }

    getCurrentYear(): string {
        const timestamp = new Date();
        return timestamp.getFullYear().toString();
    }

    matchPassword(params) {
        let formInstance = this.form.instance as any;
        let formData = formInstance.option("formData");
        params.rule.isValid = formData.Password === params.value;
        return params.rule.isValid;
    }

    onSubmit() {
        let formInstance = this.form.instance as any;
        let validateResult = formInstance.validate() as any;
        if (validateResult.isValid) {
            this.errorMessage = null;
            this.loadIndicatorVisible = true;
            let formData = formInstance.option("formData");
            this._registrationService.submitResetPasswordVerifiedRequest({
                UserName: this.userName,
                Password: formData.Password,
                Token: this.token
            })
                .subscribe(res => {
                    if (res.Status == true) {
                        this.zone.run(() => {
                            this._router.navigate(['/ResetPasswordComplete'], { queryParams: { username: this.userName }, relativeTo: this._route });
                        });
                    }
                    else {
                        this.errorMessage = res.Message;
                        this.loadIndicatorVisible = false;
                    }
                }, error => {
                    this.errorMessage = error.Message;
                    this.loadIndicatorVisible = false;
                });
        }
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./Register/ResetPasswordVerified.ts